import React from 'react';
import { ScrollViewContainer } from './styled';

const ScrollView = ({ maxHeight = '100vh', children }) => {
    return (
        <ScrollViewContainer
            className="scroll-view"
            maxHeight={maxHeight}
            paddingBottom
        >
            {' '}
            {children}
        </ScrollViewContainer>
    );
};

export default ScrollView;
